import { Injectable } from '@angular/core';
import { default as dateFormat } from 'date-fns/format';
import { timeAgo } from '@twaice-fe/frontend/shared/utilities';

@Injectable()
export class DateFormattingService {
  convertLocalToUtc(date: Date | string) {
    const dateObj = new Date(date);
    return new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60000);
  }

  convertUtcToLocal(date: Date | string) {
    const dateObj = new Date(date);
    return new Date(dateObj.getTime() - dateObj.getTimezoneOffset() * 60000);
  }

  formatAsUtc(localDate: Date, format: string) {
    const utcDate = this.convertLocalToUtc(localDate);
    return dateFormat(utcDate, format);
  }

  formatAsTimeAgoBasedOnDateWithCorrectTimeZone(localDate: Date) {
    return timeAgo(localDate);
  }

  formatAsTimeAgoBasedOnDateInterpretedAsUtc(utcDate: Date) {
    const localDate = this.convertUtcToLocal(utcDate);
    return timeAgo(localDate);
  }
}
